import { FilterValue } from './index';

type FiltersListener = (filters: FilterValue) => void;

const listeners = new Map<string, Set<FiltersListener>>();

/** Replaces the filter values of the grid mounted with this uid (its other filters and search are cleared). */
export function applyGridFilters(uid: string, filters: FilterValue): boolean {
    const set = listeners.get(uid);
    if (!set || set.size === 0) return false;
    set.forEach((listener) => listener(filters));

    return true;
}

export function subscribeGridFilters(uid: string, listener: FiltersListener): () => void {
    const set = listeners.get(uid) ?? new Set<FiltersListener>();
    set.add(listener);
    listeners.set(uid, set);

    return () => {
        set.delete(listener);
        if (set.size === 0) listeners.delete(uid);
    };
}
